module.exports = __webpack_public_path__ + "static/img/6.7066722d.jpg";